
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Settings, Plus, FileText, Download } from "lucide-react";

export function Servicos() {
  const [servicosCadastrados, setServicosCadastrados] = useState([
    { id: 1, nome: "Lavagem de Painéis", preco: "R$ 15,00", unidade: "por painel" },
    { id: 2, nome: "Troca de Disjuntor", preco: "R$ 150,00", unidade: "por unidade" },
    { id: 3, nome: "Vistoria Técnica", preco: "R$ 200,00", unidade: "por visita" },
    { id: 4, nome: "Manutenção Preventiva", preco: "R$ 300,00", unidade: "por sistema" }
  ]);

  const [novoServico, setNovoServico] = useState({
    nome: "",
    preco: "",
    unidade: "",
    descricao: ""
  });

  const [orcamentoServico, setOrcamentoServico] = useState({
    cliente: "",
    servico: "",
    quantidade: 1,
    precoPersonalizado: "",
    observacoes: ""
  });

  const clientes = [
    { id: "joao", nome: "João Silva" },
    { id: "maria", nome: "Maria Santos" },
    { id: "pedro", nome: "Pedro Costa" }
  ];

  const adicionarServico = (e: React.FormEvent) => {
    e.preventDefault();
    const id = servicosCadastrados.length + 1;
    setServicosCadastrados([...servicosCadastrados, { ...novoServico, id }]);
    setNovoServico({ nome: "", preco: "", unidade: "", descricao: "" });
    alert('Serviço cadastrado com sucesso!');
  };

  const gerarOrcamento = () => {
    const servico = servicosCadastrados.find(s => s.id.toString() === orcamentoServico.servico);
    const preco = orcamentoServico.precoPersonalizado || servico?.preco || "R$ 0,00";
    const valorNumerico = parseFloat(preco.replace('R$ ', '').replace(',', '.'));
    const total = valorNumerico * orcamentoServico.quantidade;
    
    alert(`Orçamento gerado:\nServiço: ${servico?.nome}\nQuantidade: ${orcamentoServico.quantidade}\nValor Total: R$ ${total.toFixed(2).replace('.', ',')}`);
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-gray-900 mb-2">Serviços Avulsos</h2>
        <p className="text-gray-600">Gerencie serviços extras como lavagem, manutenção e vistorias</p>
      </div>

      <Tabs defaultValue="orcamento" className="w-full">
        <TabsList className="grid w-full grid-cols-3 lg:w-auto lg:grid-cols-3">
          <TabsTrigger value="orcamento">Orçamento</TabsTrigger>
          <TabsTrigger value="servicos">Serviços</TabsTrigger>
          <TabsTrigger value="cadastrar">Cadastrar</TabsTrigger>
        </TabsList>

        <TabsContent value="orcamento" className="space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <Card className="border-0 shadow-md">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-gray-900">
                  <FileText className="h-5 w-5 text-green-600" />
                  Novo Orçamento
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div>
                  <Label htmlFor="cliente">Cliente *</Label>
                  <Select value={orcamentoServico.cliente} onValueChange={(value) => setOrcamentoServico({...orcamentoServico, cliente: value})}>
                    <SelectTrigger className="mt-1">
                      <SelectValue placeholder="Selecione o cliente" />
                    </SelectTrigger>
                    <SelectContent>
                      {clientes.map((cliente) => (
                        <SelectItem key={cliente.id} value={cliente.id}>{cliente.nome}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                <div>
                  <Label htmlFor="servico">Serviço *</Label>
                  <Select value={orcamentoServico.servico} onValueChange={(value) => setOrcamentoServico({...orcamentoServico, servico: value})}>
                    <SelectTrigger className="mt-1">
                      <SelectValue placeholder="Selecione o serviço" />
                    </SelectTrigger>
                    <SelectContent>
                      {servicosCadastrados.map((servico) => (
                        <SelectItem key={servico.id} value={servico.id.toString()}>
                          {servico.nome} - {servico.preco} {servico.unidade}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="quantidade">Quantidade</Label>
                    <Input
                      id="quantidade"
                      type="number"
                      min="1"
                      value={orcamentoServico.quantidade}
                      onChange={(e) => setOrcamentoServico({...orcamentoServico, quantidade: Number(e.target.value)})}
                      className="mt-1"
                    />
                  </div>
                  <div>
                    <Label htmlFor="precoPersonalizado">Preço Personalizado</Label>
                    <Input
                      id="precoPersonalizado"
                      value={orcamentoServico.precoPersonalizado}
                      onChange={(e) => setOrcamentoServico({...orcamentoServico, precoPersonalizado: e.target.value})}
                      placeholder="R$ 0,00"
                      className="mt-1"
                    />
                  </div>
                </div>

                <div>
                  <Label htmlFor="observacoes">Observações</Label>
                  <Textarea
                    id="observacoes"
                    value={orcamentoServico.observacoes}
                    onChange={(e) => setOrcamentoServico({...orcamentoServico, observacoes: e.target.value})}
                    placeholder="Observações do serviço..."
                    rows={3}
                    className="mt-1"
                  />
                </div>

                <div className="flex gap-2">
                  <Button 
                    onClick={gerarOrcamento}
                    className="flex-1 bg-primary hover:bg-primary/90"
                    disabled={!orcamentoServico.cliente || !orcamentoServico.servico}
                  >
                    <FileText className="h-4 w-4 mr-2" />
                    Gerar Orçamento
                  </Button>
                  <Button variant="outline">
                    <Download className="h-4 w-4 mr-2" />
                    PDF
                  </Button>
                </div>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-md">
              <CardHeader>
                <CardTitle className="text-gray-900">Preview do Orçamento</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="bg-gray-50 p-4 rounded-lg text-sm">
                  <div className="text-center mb-4">
                    <h3 className="font-bold text-lg text-gray-900">SUNSERVICE</h3>
                    <p className="text-gray-600">Orçamento de Serviços</p>
                  </div>
                  
                  <div className="space-y-2 mb-4">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Cliente:</span>
                      <span className="text-gray-900">
                        {orcamentoServico.cliente ? clientes.find(c => c.id === orcamentoServico.cliente)?.nome : '---'}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Data:</span>
                      <span className="text-gray-900">{new Date().toLocaleDateString()}</span>
                    </div>
                  </div>
                  
                  <div className="border-t pt-4 mb-4">
                    <h4 className="font-medium text-gray-900 mb-2">Serviços:</h4>
                    {orcamentoServico.servico && (
                      <div className="flex justify-between">
                        <span className="text-gray-700">
                          {servicosCadastrados.find(s => s.id.toString() === orcamentoServico.servico)?.nome} x{orcamentoServico.quantidade}
                        </span>
                        <span className="text-gray-900 font-medium">
                          {orcamentoServico.precoPersonalizado || 
                           servicosCadastrados.find(s => s.id.toString() === orcamentoServico.servico)?.preco || 'R$ 0,00'}
                        </span>
                      </div>
                    )}
                  </div>
                  
                  <div className="border-t pt-4">
                    <div className="flex justify-between font-bold text-lg">
                      <span>Total:</span>
                      <span className="text-green-600">
                        {orcamentoServico.servico ? (() => {
                          const servico = servicosCadastrados.find(s => s.id.toString() === orcamentoServico.servico);
                          const preco = orcamentoServico.precoPersonalizado || servico?.preco || "R$ 0,00";
                          const valorNumerico = parseFloat(preco.replace('R$ ', '').replace(',', '.'));
                          const total = valorNumerico * orcamentoServico.quantidade;
                          return `R$ ${total.toFixed(2).replace('.', ',')}`;
                        })() : 'R$ 0,00'}
                      </span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </TabsContent>

        <TabsContent value="servicos">
          <Card className="border-0 shadow-md">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-gray-900">
                <Settings className="h-5 w-5 text-green-600" />
                Serviços Cadastrados
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {servicosCadastrados.map((servico) => (
                  <div key={servico.id} className="p-4 border rounded-lg hover:bg-gray-50">
                    <h4 className="font-medium text-gray-900 mb-2">{servico.nome}</h4>
                    <div className="text-sm text-gray-600 mb-3">
                      <div className="flex justify-between">
                        <span>Preço:</span>
                        <span className="font-medium text-gray-900">{servico.preco}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Unidade:</span>
                        <span>{servico.unidade}</span>
                      </div>
                    </div>
                    <div className="flex gap-1">
                      <Button variant="outline" size="sm" className="flex-1">Editar</Button>
                      <Button variant="outline" size="sm">Remover</Button>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="cadastrar">
          <Card className="border-0 shadow-md">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-gray-900">
                <Plus className="h-5 w-5 text-green-600" />
                Cadastrar Novo Serviço
              </CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={adicionarServico} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="nome">Nome do Serviço *</Label>
                    <Input
                      id="nome"
                      value={novoServico.nome}
                      onChange={(e) => setNovoServico({...novoServico, nome: e.target.value})}
                      placeholder="Ex: Lavagem de Painéis"
                      required
                      className="mt-1"
                    />
                  </div>
                  <div>
                    <Label htmlFor="preco">Preço Padrão *</Label>
                    <Input
                      id="preco"
                      value={novoServico.preco}
                      onChange={(e) => setNovoServico({...novoServico, preco: e.target.value})}
                      placeholder="R$ 0,00"
                      required
                      className="mt-1"
                    />
                  </div>
                  <div>
                    <Label htmlFor="unidade">Unidade *</Label>
                    <Select value={novoServico.unidade} onValueChange={(value) => setNovoServico({...novoServico, unidade: value})}>
                      <SelectTrigger className="mt-1">
                        <SelectValue placeholder="Selecione a unidade" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="por painel">por painel</SelectItem>
                        <SelectItem value="por unidade">por unidade</SelectItem>
                        <SelectItem value="por visita">por visita</SelectItem>
                        <SelectItem value="por sistema">por sistema</SelectItem>
                        <SelectItem value="por hora">por hora</SelectItem>
                        <SelectItem value="valor fixo">valor fixo</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div>
                  <Label htmlFor="descricao">Descrição do Serviço</Label>
                  <Textarea
                    id="descricao"
                    value={novoServico.descricao}
                    onChange={(e) => setNovoServico({...novoServico, descricao: e.target.value})}
                    placeholder="Descreva o que está incluído neste serviço..."
                    rows={3}
                    className="mt-1"
                  />
                </div>
                
                <div className="flex justify-end">
                  <Button type="submit" className="bg-primary hover:bg-primary/90 px-8">
                    Cadastrar Serviço
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
